import createHashHistory from 'history/lib/createHashHistory';
export default createHashHistory();


// WEBPACK FOOTER //
// ./src/history.js